import React from 'react';
import { Search, Copy, Edit } from 'lucide-react';

const getMomentLabel = (moment) => {
  const nonTechnical = moment.content?.nonTechnical?.general;
  const technical = moment.content?.technical?.general;
  return nonTechnical?.name || technical?.name || 'Untitled Moment';
};

const getMomentDescription = (moment) => {
  const nonTechnical = moment.content?.nonTechnical?.general;
  const technical = moment.content?.technical?.general;
  return nonTechnical?.description || technical?.description || '';
};

export default function StoryboardSidebar({
  chapters,
  searchQuery,
  selectedMoment,
  onSearchChange,
  onMomentSelect,
  isTechnicalMode,
  noscrollbar,
}) {
  return (
    <div
      className="w-[380px] h-[calc(100vh-130px)] rounded-lg p-4 flex flex-col"
      style={{ minHeight: '600px' }}
    >
      {!isTechnicalMode && <div className="bg-[#292A2E] rounded-lg p-4 mb-6">
        <div className="mb-4 ">
          <h2 className="text-lg font-semibold mb-1 text-white">Storyboard</h2>
          <div className="flex gap-4 text-xs text-gray-400">
            <span>{chapters.length} chapters</span>
            <span>
              {chapters.reduce((sum, ch) => sum + (ch.moments?.length || 0), 0)}{' '}
              Moments
            </span>
          </div>
        </div>

        {/* Search Bar */}
        <div className="relative mb-4">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search moments and chapters..."
            className="w-full bg-zinc-800 text-white text-sm rounded px-10 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
          />
        </div>
      </div>}
      {/* Chapters and Moments List */}
      <div className={`flex-1 overflow-y-auto rounded-lg p-4 mb-6 custom-scrollbar ${noscrollbar ? 'scrollbar' : 'custom-scrollbar'} ${isTechnicalMode ? ' bg-[#1E1F22]' : 'bg-[#292A2E]'}`}>
        <div className="space-y-4">
          {chapters.map((chapter) => (
            <div key={chapter.id} className="space-y-2 ]">
              <div className="flex items-center gap-2 text-sm">
                <div className="w-6 h-6 bg-red-600 text-white rounded-full flex items-center justify-center text-xs font-bold">
                  {chapter.number}
                </div>
                <span className="font-medium">Chapter - {chapter.number}</span>
                <span className="text-xs text-gray-400">
                  {chapter.moments?.length || 0} moments
                </span>
              </div>

              <div className="ml-8 space-y-1">
                {(chapter.moments || [])
                  .filter(
                    (moment) =>
                      !searchQuery ||
                      getMomentLabel(moment)
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()) ||
                      getMomentDescription(moment)
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                  )
                  .map((moment) => (
                    <div
                      key={moment.id}
                      onClick={() => onMomentSelect(moment.id)}
                      className={`p-3 bg-[#404040] rounded cursor-pointer transition-colors ${
                        selectedMoment === moment.id
                          ? 'bg-red-600 border-2 border-red-500'
                          : 'bg-zinc-800 hover:bg-zinc-700'
                      }`}
                    >
                      <div className="flex items-start justify-between mb-1">
                        <h3 className="text-sm font-medium text-white flex-1">
                          {getMomentLabel(moment)}
                        </h3>
                        <div className="flex gap-1 flex-shrink-0">
                          <button
                            className="p-1 hover:bg-zinc-700 rounded transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              // Handle copy action
                            }}
                          >
                            <Copy className="w-3 h-3 text-gray-400" />
                          </button>
                          <button
                            className="p-1 hover:bg-zinc-700 rounded transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              // Handle edit action
                            }}
                          >
                            <Edit className="w-3 h-3 text-gray-400" />
                          </button>
                        </div>
                      </div>
                      <p className="text-xs text-gray-400 line-clamp-2">
                        {getMomentDescription(moment)}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
